import React, {useEffect, useState} from "react";
import {Select} from "antd";
import {WidgetProps} from "../../../../../common/ui/input/widget/widget";
import {healthCheckerService} from "../../../../../../services/health-checker/health-checker.service";

export const UIInputWidgetHealthChecker: React.FC<WidgetProps> = ({value, onChange, multiple, loading}) => {
    const [checkers, setCheckers] = useState<string[]>([]);
    const [checkersLoading, setCheckersLoading] = useState(false);

    useEffect(() => {
        setCheckersLoading(true);
        healthCheckerService
            .getCheckers()
            .then(setCheckers)
            .finally(() => setCheckersLoading(false));
    }, []);

    return (
        <Select
            mode={multiple ? "multiple" : undefined}
            onChange={onChange as any}
            value={value as any}
            allowClear
            showSearch
            optionFilterProp="children"
            loading={loading || checkersLoading}
        >
            {checkers.map((checker) => (
                <Select.Option key={checker} value={checker}>
                    {checker}
                </Select.Option>
            ))}
        </Select>
    );
};
